import { render, staticRenderFns } from "./ExcelRTDDownload.vue?vue&type=template&id=52847541&"
import script from "./ExcelRTDDownload.vue?vue&type=script&lang=js&"
export * from "./ExcelRTDDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports